import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyCB6IfQzqc63bCpSN4ldELPcaUCWmOq1B4",
  authDomain: "stitch-guy-cb7d1.firebaseapp.com",
  projectId: "stitch-guy-cb7d1",
  storageBucket: "stitch-guy-cb7d1.firebasestorage.app",
  messagingSenderId: "16164587183",
  appId: "1:16164587183:web:0fe4cb9a5e4ac763f8365a"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);

export const storage = getStorage(app);
